import React from 'react'
import coming from "../../assets/img/coming-5942155_1280.jpg"

const ComingSoon = () => {
  return (
    <div >
        <img style={{width:"500px", borderRadius:"50px",boxShadow:"2px 2px 2px  15px cadetblue", margin:"2rem"}} src={coming} alt="" />
    </div>
  )
}

export default ComingSoon